import api from './api';
import type { DashboardOverview } from '../types/device';

interface ApiResponse<T> {
  success: boolean;
  data: T;
}

export async function getDashboardOverview(): Promise<DashboardOverview> {
  const { data } = await api.get<ApiResponse<DashboardOverview>>('/dashboard/overview');
  return data.data;
}

export async function getDashboardStatus() {
  const { data } = await api.get('/dashboard/status');
  return data.data;
}

export async function getColdStorages() {
  const { data } = await api.get('/devices/cold-storage');
  return data.data;
}

export async function getHitachi() {
  const { data } = await api.get('/devices/hitachi');
  return data.data;
}

export async function getIot627() {
  const { data } = await api.get('/devices/iot627');
  return data.data;
}

export async function getAiBox() {
  const { data } = await api.get('/devices/ai-box');
  return data.data;
}

export async function getHeartbeat() {
  const { data } = await api.get('/devices/heartbeat');
  return data.data;
}

export async function getRealtimeStatus() {
  const { data } = await api.get('/system/realtime-status');
  return data.data;
}

export interface SignaturePayload {
  password: string;
  comment: string;
}

export interface DeviceControlParams {
  device_key: string;
  param: string;
  value: number;
  signature?: SignaturePayload;
}

export interface DeviceControlResult {
  device_key: string;
  param: string;
  value: number;
  unit: string;
  raw_value: number;
  offset: number;
}

export async function writeDeviceParam(
  params: DeviceControlParams
): Promise<DeviceControlResult> {
  const { data } = await api.post<ApiResponse<DeviceControlResult>>(
    '/devices/control',
    params
  );
  return data.data;
}

export interface WritableParam {
  device_key: string;
  param: string;
  min: number;
  max: number;
  unit: string;
}

export async function getWritableParams(): Promise<WritableParam[]> {
  const { data } = await api.get<ApiResponse<WritableParam[]>>('/devices/writable-params');
  return data.data;
}

// ---- 設備維護模式 ----

export interface MaintenanceInfo {
  reason: string;
  started_by: string;
  started_at: string;
}

export async function getDeviceMaintenance(): Promise<Record<string, MaintenanceInfo>> {
  const { data } = await api.get<ApiResponse<Record<string, MaintenanceInfo>>>('/system/device-maintenance');
  return data.data;
}

export async function setDeviceMaintenance(
  deviceKey: string,
  enabled: boolean,
  reason?: string,
  signature?: SignaturePayload,
): Promise<Record<string, MaintenanceInfo>> {
  const { data } = await api.put<ApiResponse<Record<string, MaintenanceInfo>>>(
    '/system/device-maintenance',
    { device_key: deviceKey, enabled, reason: reason || '', signature },
  );
  return data.data;
}

export async function triggerDefrost(
  deviceKey: string,
  signature?: SignaturePayload,
): Promise<{ device_key: string; raw_value: number; offset: number }> {
  const { data } = await api.post<ApiResponse<{ device_key: string; raw_value: number; offset: number }>>(
    '/devices/defrost-trigger',
    { device_key: deviceKey, signature }
  );
  return data.data;
}
